import { DashboardCollectorModel as Model } from './Model'


export const MODULE_NAME = 'dashboard-collector'

export const DASHBOARD_COLLECTOR_ROUTES = {
  LAYOUT: MODULE_NAME,
  INDEX: `${MODULE_NAME}.index`,
} as const

export const MENU = {
  id: DASHBOARD_COLLECTOR_ROUTES.LAYOUT,
  route: { name: DASHBOARD_COLLECTOR_ROUTES.LAYOUT },
  label: Model.page_title.index,
  icon: 'mdi-view-dashboard',
} as const
